export function compareEnum<T extends string>(values: T[]) {
  const valuesIndex: Record<string, number> = Object.fromEntries(
    values.map((value, index) => [value, index]),
  );

  return function compare(a: T, b: T) {
    return valuesIndex[a] - valuesIndex[b];
  };
}
